<template>
  <div class="uk-section">
    <div class="uk-container">
      <div class="uk-width-1-2 uk-width-1-3@m uk-margin-auto">
        <div class="uk-card uk-card-default uk-card-body">
          <h1>Registro</h1>
          <form @submit.prevent="register" class="uk-form-stacked">
            <div class="uk-margin">
              <label class="uk-form-label" for="form-stacked-text">Email</label>
              <div class="uk-form-controls">
                <input
                  class="uk-input"
                  type="email"
                  placeholder="Email"
                  v-model="email"
                />
              </div>
            </div>
            <div class="uk-margin">
              <label class="uk-form-label" for="form-stacked-text"
                >Contraseña</label
              >
              <div class="uk-form-controls">
                <input
                  class="uk-input"
                  type="password"
                  placeholder="Contraseña"
                  v-model="password"
                />
              </div>
            </div>
            <div class="uk-margin">
              <button class="uk-button uk-button-primary">Registrar</button>
            </div>
            <p class="uk-text-center">Ya tiene cuenta, <router-link to="/login">Ingresar</router-link></p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
export default {
  name: "Register",
  data() {
    return {
      email: "",
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    register() {
      const auth = getAuth();
      createUserWithEmailAndPassword(auth, this.email, this.password)
        .then((userCredential) => {
          // Signed in
          alert("Yeah!!, Ya estas registrado!!");
          this.$router.push("/login");
        })
        .catch((error) => {
          alert(error.message);
        });
    },
  },
};
</script>
